import { H3 } from '@/components'
import { PhoneInput } from '@/components_deprecated'
import { safeParsePhoneNumber } from '@/utils/parsing'
import type { FormErrors, UpdateFormFn } from '@ur-solutions/react-hooks'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import styled from 'styled-components'
import type { ProfileUserNode } from '..'
import type { ProfileEditForm } from '../types'
import { InputArea, OldInput, OldProfileCard } from './components'

const Wrapper = styled(OldProfileCard)`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas:
    'header header'
    'name   phone';
  gap: 1.5rem;

  header {
    grid-area: header;
  }

  ${props => props.theme.media.mobile} {
    grid-template-columns: 1fr;
    grid-template-areas:
      'header'
      'name'
      'phone';
    gap: 1rem;
  }
`

interface ContactPersonProps {
  user: ProfileUserNode | null
  editing: boolean
  editForm: ProfileEditForm
  errors: FormErrors<ProfileEditForm>

  onUpdateForm: UpdateFormFn<ProfileEditForm>
}

export const ContactPerson: React.FC<ContactPersonProps> = ({
  user,
  editing,
  editForm,
  errors,

  onUpdateForm,
}) => {
  const translations = useTranslate({
    contactPerson: 'common.contact-person',
    name: 'common.name',
    phoneNumber: 'common.phone-number',
  })

  return (
    <Wrapper>
      <header>
        <H3>{translations.contactPerson}</H3>
      </header>

      <InputArea $area="name">
        <label>{translations.name}</label>
        <OldInput
          value={editForm.contactPersonName}
          error={errors.contactPersonName}
          editing={editing}
          onChange={contactPersonName => onUpdateForm({ contactPersonName })}
        />
      </InputArea>

      <InputArea $area="phone">
        <label>{translations.phoneNumber}</label>
        {editing ? (
          <PhoneInput
            value={editForm.contactPersonPhoneNumber}
            error={errors.contactPersonPhoneNumber}
            height="54px"
            background="inherit"
            onChange={contactPersonPhoneNumber =>
              onUpdateForm({ contactPersonPhoneNumber })
            }
          />
        ) : (
          <OldInput
            value={safeParsePhoneNumber(editForm.contactPersonPhoneNumber)}
            editing={editing}
            iconRightProps={{
              icon: 'phone',
              type: 'solid',
              cursor: 'pointer',
              onClick: () =>
                window.open(`tel:${user?.contactPersonPhoneNumber}`),
            }}
            onChange={() => void 0}
          />
        )}
      </InputArea>
    </Wrapper>
  )
}
